import {
  createMcpCredentialResponse,
  listMcpCredentialsResponse,
  type CreateMcpCredentialResponse,
  type McpCredentialSummary,
} from '@occ/contracts';
import { del, get, post } from '../api/http';
import { ROUTES } from '../api/routes';

/**
 * Credenciales personales MCP (RF-13, autoservicio).
 *
 * El token en claro solo viaja en la respuesta de `createMcpCredential`: a
 * partir de ahí el backend solo guarda su hash, igual que con la contraseña
 * temporal de un usuario nuevo o un token de enrollment.
 */

export const createMcpCredential = (name: string): Promise<CreateMcpCredentialResponse> =>
  post(ROUTES.mcpCredentials, { name }, createMcpCredentialResponse);

export const listMcpCredentials = async (): Promise<McpCredentialSummary[]> =>
  (await get(ROUTES.mcpCredentials, listMcpCredentialsResponse)).credentials;

export const revokeMcpCredential = (id: string): Promise<void> => del(ROUTES.mcpCredential(id));
